export default function () {
	$('.decorations-coupon').each(function () {
		let $this = $(this);
		let $coupon = $this.find('.decorations-coupon__coupon');
		let timeoutId = null;

		let writeCouponToClipboard = function () {
			clearTimeout(timeoutId);
			navigator.clipboard.writeText($coupon.text());
			$coupon.addClass('decorations-coupon__coupon_saved');
			timeoutId = setTimeout(function () {
				$coupon.removeClass('decorations-coupon__coupon_saved');
			}, 1000);
		};

		$coupon.on('click', writeCouponToClipboard);
		$this.find('.decorations-coupon__clip-button').on('click', writeCouponToClipboard);
	});
};
